module.exports = __webpack_public_path__ + "static/media/wallpaper.e8147bbe.jpg";